var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99016 5.98918C6.38069 5.59866 7.01385 5.59866 7.40438 5.98918L12.0006 10.5854L16.5968 5.98919C16.9873 5.59866 17.6204 5.59866 18.011 5.98919C18.4015 6.37971 18.4015 7.01287 18.011 7.4034L13.4148 11.9996L18.011 16.5958C18.4016 16.9864 18.4016 17.6195 18.011 18.0101C17.6205 18.4006 16.9873 18.4006 16.5968 18.0101L11.9999 13.4145L7.40437 18.01C7.01385 18.4005 6.38068 18.4005 5.99016 18.01C5.59963 17.6195 5.59963 16.9863 5.99016 16.5958L10.5856 12.0003L5.99016 7.4034C5.59964 7.01288 5.59964 6.37971 5.99016 5.98918Z",
    fill: "#969FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.aca0010c89f8d8e9afb8cc241b232f04.svg";
export { ForwardRef as ReactComponent };